import React, { useState } from "react";
import useSWR from "swr";
import { Loader } from "../../../../Components/Common/Loader";
import PDFViewer from "../../../../Components/Common/SecurePDFViewer";
import Modal from "../../../../Components/Common/Modal";
import { Link, useLocation } from "react-router-dom";
import Button from "../../../../Components/Common/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Tabs from "../../../../Components/Common/Tabs";
import { studentSubscriptionMaterialTabsData } from "../../../../data/SidebarData";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import { publicUrls, studentUrls } from "../../../../Api/Auth/AppUrls";
import QueryString from "qs";
import { orderUrls } from "../../../../Api/Auth/ApiUrls";
import { fileFetcher } from "../../../../Api/swrConfig";
import { useAuth } from "../../../../Context/AuthContext";
import { checkStudentRouteVisibility } from "../../../../utils/findStudentRouteBySlug";
import NotFound from "../../../Notfound";
import { getSubscriptionRemainingDays } from "../../../../utils/subscriptionStatus";

const StudentSubscriptionMaterialsMechanical = () => {
  const { userData, categoryData } = useAuth();
  const location = useLocation();
  const [selected, setSelected] = useState(null);
  const isVisibleCivil = checkStudentRouteVisibility(
    categoryData,
    studentUrls.studentSubscriptionMaterials
  );
  const isVisibleMechanical = checkStudentRouteVisibility(
    categoryData,
    studentUrls.studentSubscriptionMaterialsMechanical
  );
  const visibleTabs = studentSubscriptionMaterialTabsData.filter((tab) => {
    if (!tab?.path) return true;
    if (tab.path === studentUrls.studentSubscriptionMaterials && !isVisibleCivil)
      return false;
    if (
      tab.path === studentUrls.studentSubscriptionMaterialsMechanical &&
      !isVisibleMechanical
    )
      return false;
    return true;
  });

  const parts = location.pathname.split("/").filter(Boolean);
  const dynamicPath = `/${parts[0]}/${parts[1]}-${parts[2]}`;
  const dynamicSlug = dynamicPath.split("/")[dynamicPath.split("/").length - 1];

  const apiQueryParams = {
    userId: userData?._id,
    itemType: "material",
    slug: dynamicSlug,
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);

  const { isLoading, data } = useSWR(orderUrls.purchases(apiQueryString));
  const { data: fileUrl, isLoading: fileLoading } = useSWR(
    selected?.link || null,
    (url) => fileFetcher(url)
  );

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={visibleTabs} />
      {!isVisibleMechanical ? (
        <NotFound />
      ) : (
        <>
          {isLoading ? (
            <Loader />
          ) : // eslint-disable-next-line
          data?.data == {} ? (
            <span className=" mt-2  flex flex-col justify-center gap-2 text-center items-center">
              No available content. Purchase subscription material to get
              started.
              <Link to={publicUrls.feSubscriptionMechanical}>
                <Button>Subscription Materials</Button>
              </Link>
            </span>
          ) : data?.data?.purchased ? (
            (() => {
              const purchasedAt = data?.data?.purchasedAt;
              const duration = data?.data?.subscriptionDuration;
              const remainingDays = getSubscriptionRemainingDays(
                purchasedAt,
                duration
              );

              if (remainingDays === null) {
                return (
                  <div className="text-red-600 font-semibold">
                    ⚠️ Subscription data is missing or invalid.
                  </div>
                );
              }

              if (remainingDays === 0) {
                return (
                  <span className="mt-2 flex flex-col justify-center gap-2 text-center items-center">
                    <p className="font-semibold text-gray-700">
                      Your subscription has expired.
                    </p>
                    <p className="text-sm text-gray-600">
                      Renew your subscription to access materials again.
                    </p>
                    <Link to={publicUrls.feSubscriptionMechanical}>
                      <Button>Renew Subscription</Button>
                    </Link>
                  </span>
                );
              }

              return (
                <>
                  <p className="font-semibold mt-4">
                    <span className="text-gray-700">
                      {` Your subscription expires in ${remainingDays} day${
                        remainingDays > 1 ? "s" : ""
                      }.`}
                    </span>
                  </p>
                  <div className="container mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-6 p-6">
                    {data?.data?.materials?.length
                      ? data.data.materials.map((item) => (
                          <div
                            key={item._id}
                            className="bg-white shadow-lg hover:shadow-xl rounded-lg p-4 transition-all duration-300"
                          >
                            <button className="block w-full flex justify-center">
                              <img
                                src="/pdfImage.png"
                                alt={item.title}
                                className="w-36 h-36 object-cover transform group-hover:scale-110 transition-transform duration-300"
                              />
                            </button>
                            <div className="flex flex-col items-center mt-3 gap-1">
                              <h2 className="text-sm font-semibold">
                                {item.title}
                              </h2>
                              <Button
                                className="flex gap-2 items-center mt-2"
                                onClick={() => setSelected(item)}
                              >
                                <FontAwesomeIcon icon={faEye} />
                                View
                              </Button>
                            </div>
                          </div>
                        ))
                      : ""}
                  </div>
                </>
              );
            })()
          ) : (
            <span className=" mt-2  flex flex-col justify-center gap-2 text-center items-center">
              No available content. Purchase subscription material to get
              started.
              <Link to={publicUrls.feSubscriptionMechanical}>
                <Button>Subscription Materials</Button>
              </Link>
            </span>
          )}
          <Modal
            isOpen={selected !== null}
            title={"View Subscription Material"}
            onCancel={() => setSelected(null)}
            footer={false}
            fullHeight
          >
            <div
              style={{
                width: "100%",
                height: "750px", // Set fixed height here instead of in PDFViewer
                position: "relative",
                border: "1px solid rgba(0, 0, 0, 0.3)",
              }}
              className="pdf-viewer-wrapper"
            >
              {fileLoading ? <Loader /> : <PDFViewer pdfUrl={fileUrl} />}
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};

export default StudentSubscriptionMaterialsMechanical;
